import $http from '../../../../../axios-instance';

/**
 * Obtener frases no peligrosas por versión.
 *
 * @param Object commit
 * @param Integer versionId
 */
export async function getPhrasesNotDangerByVersionId({ commit }, versionId) {
    commit("dashboard/load", true, { root: true });
    try {
        const { data: response } = await $http.get(`sga2/sub-not-dangers/by-version/${versionId}`);
        commit("setProductSga2subsNotDangers", response.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}